export default "__VITE_ASSET__BbfJVNZm__"